import { useEffect as l, useRef as i } from "react";
import { useEvent as r } from './use-event.js';
let u = Symbol();
function T(t) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return Object.assign(t, {
    [u]: n
  });
}
function y() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }
  let n = i(t);
  l(() => {
    n.current = t;
  }, [t]);
  let c = r(e => {
    for (let o of n.current) o != null && (typeof o == "function" ? o(e) : o.current = e);
  });
  return t.every(e => e == null || (e == null ? void 0 : e[u])) ? void 0 : c;
}
export { T as optionalRef, y as useSyncRefs };